import { ILayoutConfig, IMailConfig, ISecurityConfig, IAzureADOptions, ICompanyConfig } from './data/web-api-client';
import * as msal from '@azure/msal-browser';

export interface IAuthConfig {
  msalInstance: msal.PublicClientApplication | null;
}

export const AuthConfig: IAuthConfig = {
  msalInstance: null
};

export const SecurityConfig: ISecurityConfig = {
  administrationGroup: "",
  calculatorGroup: "",
  hrGroup: "",
  administratorGroup: "",
  qualityGuardGroup: "",
  qualityGuardOneSkinGroup: "",
  projectCoordinatorGroup: "",
  userGroup: "",
  invoicingRead: "",
  articleReadWrite: "",
  quotationRead: "",
  machineryRead: "",
  machineryReadWrite: "",
  purchaseRead: "",
  purchaseOrderRead: "",
  taskAdmin: "",
}

export enum UblType {
  Invoice,
  CreditNote
}

export const CompanyConfig: ICompanyConfig = {
  companyName: "",
  firstName:  "",
  lastName:  "",
  street:  "",
  streetNumber:  "",
  city:  "",
  postalCode: "",
  country: "",
  email: "",
  invoiceAccountantEmail:  "",
  creditNoteAccountantEmail:  "",
  timeZone: "",
  vatNumber:  "",
  invoiceDocumentNumberFormat:  ""
}

export const LayoutConfig: ILayoutConfig = {
  faviconPrefix: "",
  headTitle: "",
  footerText: "",
  navbarLogoUrl: "",
  navbarCompanyName: ""
};

export const MailConfig: IMailConfig = {
  infoMailAddress: "",
  accountingMailAddress: "",
  executionMailAddress: "",
  fromName: "",
  erpReportingName: ""
}

export const AzureADOptions: IAzureADOptions = {
  clientId: ""
}